import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { licensesAPI } from '../services/api';
import { format } from 'date-fns';

const Licenses = () => {
  const [licenses, setLicenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    status: '',
    license_type: '',
    expiring_soon: false
  });

  useEffect(() => {
    fetchLicenses();
  }, [filters]);

  const fetchLicenses = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.status) params.status = filters.status;
      if (filters.license_type) params.license_type = filters.license_type;
      if (filters.expiring_soon) params.expiring_soon = 'true';

      const response = await licensesAPI.list(params);
      setLicenses(response.data.results || response.data);
    } catch (err) {
      console.error('Failed to fetch licenses:', err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (license) => {
    if (license.is_expired) return <span className="badge badge-danger">Expired</span>;
    if (license.is_expiring_soon) return <span className="badge badge-warning">Expiring Soon</span>;
    if (license.status === 'active') return <span className="badge badge-success">Active</span>;
    if (license.status === 'revoked') return <span className="badge badge-danger">Revoked</span>;
    return <span className="badge badge-gray">{license.status}</span>;
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Licenses</h1>
          <p className="page-description">Manage all software licenses</p>
        </div>
        <Link to="/dashboard/licenses/create" className="btn btn-primary">
          Create License
        </Link>
      </div>

      <div className="card">
        {/* Filters */}
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
          <select
            className="form-select"
            style={{ width: 'auto' }}
            value={filters.status}
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
          >
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="pending">Pending</option>
            <option value="revoked">Revoked</option>
          </select>

          <select
            className="form-select"
            style={{ width: 'auto' }}
            value={filters.license_type}
            onChange={(e) => setFilters({ ...filters, license_type: e.target.value })}
          >
            <option value="">All Types</option>
            <option value="trial">Trial</option>
            <option value="single">Single User</option>
            <option value="team">Team</option>
            <option value="enterprise">Enterprise</option>
          </select>

          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={filters.expiring_soon}
              onChange={(e) => setFilters({ ...filters, expiring_soon: e.target.checked })}
            />
            Expiring within 30 days
          </label>
        </div>

        {loading ? (
          <div className="loading-container"><div className="spinner"></div></div>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Customer</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Expiry Date</th>
                  <th>Days Left</th>
                  <th>Activations</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {licenses.map((license) => (
                  <tr key={license.id}>
                    <td>
                      <Link to={`/dashboard/licenses/${license.id}`} className="link font-medium">
                        {license.customer_name}
                      </Link>
                    </td>
                    <td style={{ textTransform: 'capitalize' }}>{license.license_type}</td>
                    <td>{getStatusBadge(license)}</td>
                    <td>{format(new Date(license.expiry_date), 'MMM d, yyyy')}</td>
                    <td>
                      {license.is_expired ? (
                        <span style={{ color: 'var(--danger)' }}>Expired</span>
                      ) : (
                        <span style={{ color: license.days_until_expiry <= 30 ? 'var(--warning)' : 'inherit' }}>
                          {license.days_until_expiry} days
                        </span>
                      )}
                    </td>
                    <td>{license.activation_count} / {license.max_activations}</td>
                    <td>
                      <Link to={`/dashboard/licenses/${license.id}`} className="btn btn-sm btn-secondary">
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Licenses;
